import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { TotalesMedico } from '../models/totales-generales.interface';
import { LoaderService } from '../shared/loader/services/loader.service';
import { Medico } from '../models/medico.interface';
import { Institucion } from '../models/institucion.interface';
import { Estado } from '../models/estado.interface';
import { Hospital } from '../models/hospital.interface';
import { Catalogo } from '../models/catalogos.interface';
import { Producto } from '../models/producto.interface';
import { AsignacionCodigosAlCasoClinicos, CasoClinico, Cirugia, Ficha, Folio } from '../models/caso-clinico.interface';
import { DocumentoCasoClinico } from '../models/documento-caso-clinico.interface';
import { Especialidad } from '../models/especialidad.interface';
import { MedicoRequest } from '../models/enfermera-request.interface';
import { FechasCasoClinco } from '../models/fechas-caso-clinico';
import { EstadoCuenta } from '../models/estado-cuenta.interface';
import { CanjeMedico, RedimirMedico, SolicitudCanjeMedico } from '../models/redimir.interface';

const httpOptions = {
  headers: new HttpHeaders({

    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',

  })
};

@Injectable({
  providedIn: 'root'
})
export class MedicoService {

  constructor(private httpclient: HttpClient, private loaderService: LoaderService) { }

  nuevoMedico(medico: MedicoRequest): Observable<HttpRespuesta<Medico>> {
    this.loaderService.activar()
    return this.httpclient.post<HttpRespuesta<Medico>>(environment.api.medicos, medico, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  totales(id: number): Observable<HttpRespuesta<TotalesMedico>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<TotalesMedico>>(environment.api.medicoTotales + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }
  getMedicos(id: number): Observable<HttpRespuesta<Medico>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Medico>>(environment.api.medicos + "/" + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }
  getCasoClinico(id: string): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<CasoClinico>>(environment.api.casosclinicos + "/" + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }
  getEspecialidades(): Observable<Especialidad[]> {
    return this.httpclient.get<Especialidad[]>(environment.api.catalogos + 'especialidades', httpOptions);
  }
  getPuestos(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'puestos', httpOptions);
  }
  getInstituciones(): Observable<Institucion[]> {
    return this.httpclient.get<Institucion[]>(environment.api.catalogos + 'instituciones', httpOptions);
  }
  getEstados(): Observable<Estado[]> {
    return this.httpclient.get<Estado[]>(environment.api.catalogos + 'estados', httpOptions);
  }
  getDiagnosticos(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'diagnosticos', httpOptions);
  }
  getAntibioticos(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'antibioticos', httpOptions);
  }
  getSeccionCuerpo(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'seccionescuerpo', httpOptions);
  }
  getUsosProducto(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'usosproductos', httpOptions);
  }
  getAcciones(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'acciones', httpOptions);
  }
  getTiposDocumentos(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'tiposdocumentos', httpOptions);
  }
  getHospitales(fk_institucion: number | null, fk_estado: number | null): Observable<Hospital[]> {
    return this.httpclient.post<Hospital[]>(environment.api.catalogos + 'hospitales', { fk_institucion, fk_estado }, httpOptions);
  }
  getCodigo(codigo: string): Observable<HttpRespuesta<Producto>> {
    return this.httpclient.get<HttpRespuesta<Producto>>(environment.api.codigo + codigo, httpOptions);
  }
  setCasoClinicoFichaNuevo(ficha: Ficha): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<CasoClinico>>(environment.api.casosclinicos, ficha, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setCasoClinicoFichaActualizar(ficha: Ficha, idCasoClinico: string): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.put<HttpRespuesta<CasoClinico>>(environment.api.actualizarCasoClinicoFicha + idCasoClinico, ficha, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setCasoClinicoCirugiaActualizar(cirugia: Cirugia, idCasoClinico: string): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.put<HttpRespuesta<CasoClinico>>(environment.api.actualizarCasoClinicoCirugia + idCasoClinico, cirugia, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setAsignarCodigo(codigo: string, fk_casoClinico: number): Observable<CasoClinico> {
    return this.httpclient.post<CasoClinico>(environment.api.asignarcodigocasoclinico, { codigo, fk_casoClinico }, httpOptions)
  }
  subirDocumento(formData: FormData): Observable<HttpRespuesta<DocumentoCasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<DocumentoCasoClinico>>(environment.api.subirDocumento, formData, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  elimiarDocumento(id: number): Observable<HttpRespuesta<DocumentoCasoClinico[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<DocumentoCasoClinico[]>>(environment.api.eliminarDocumentoCasoClinico + id.toString(), httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }
  eliminarCasoClinico(id: number): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.delete<HttpRespuesta<CasoClinico>>(environment.api.casosclinicos + "/" + id.toString(), httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }
  getFolioNuevo(id: string): Observable<HttpRespuesta<Folio>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Folio>>(environment.api.folionuevo + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asignarCodigosCasoClinico(asignar: AsignacionCodigosAlCasoClinicos): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<CasoClinico>>(environment.api.asignarcodigosalcasoclinico, asignar, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getFechasCasoClinico(id: string): Observable<HttpRespuesta<FechasCasoClinco>> {
    return this.httpclient.get<HttpRespuesta<FechasCasoClinco>>(environment.api.fechasCasoClinico + id, httpOptions);
  }
  getEstadoCuenta(id: number): Observable<EstadoCuenta[]> {
    this.loaderService.activar();
    return this.httpclient.get<EstadoCuenta[]>(environment.api.estadoCuentaMedico + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setSolicitudCanje(canje: SolicitudCanjeMedico): Observable<HttpRespuesta<RedimirMedico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirMedico>>(environment.api.solicitudCanjeMedico, canje, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimir(canje: CanjeMedico): Observable<HttpRespuesta<RedimirMedico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirMedico>>(environment.api.redimirCreateMedico, canje, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getRedimirMedicoDetalles(id: string): Observable<HttpRespuesta<RedimirMedico>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<RedimirMedico>>(environment.api.redimirMedicoAtender + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  getMedicoPreSolicitud(id: number): Observable<HttpRespuesta<Medico>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Medico>>(environment.api.presolicitudCanjeMedico + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

}
